import { action, makeAutoObservable, observable, runInAction } from 'mobx';
import { HTTP_STATUS_RESPONSE_KEY } from 'src/constants/api';
import { ResponseDTO } from 'src/dto/base.dto';
import { GetInvestmentDetailDTO } from 'src/dto/funder-investment.dto';
import { IInvestmentDetail } from 'src/interfaces/mortgage-deal/investment';
import { HttpService } from 'src/services/http.service';

export interface IFunderInvestmentDetailStore {
	item?: IInvestmentDetail;
	fetchItem(biddingId: string): Promise<void>;
  dispose(): void;
}
export class FunderInvestmentDetailStore implements IFunderInvestmentDetailStore {
	item?: IInvestmentDetail;

	constructor(private readonly http: HttpService) {
		makeAutoObservable(this, {
			item: observable,
      dispose: action.bound
		});
	}
  public  dispose(): void {
    this.item = undefined;
  }
	public async fetchItem(biddingId: string): Promise<void> {
		const dto = new GetInvestmentDetailDTO({
			biddingId
		});
		const rs: ResponseDTO<IInvestmentDetail> = await this.http.request(dto);
		if (rs.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			runInAction(() => {
				if (rs.data) {
					this.item = {
						...rs.data
					};
				}
			});
		}
	}
}
